import React, { useEffect, useState } from "react";
import ConsentDetailComponent from "./consentDetailComponent";
import { useParams } from "react-router";
import Utils from "../../../utility";
import { UserConsent } from "../../../services";
import { failureMessageConstant, keyConstants } from "../../../constants";
import { useDispatch } from "react-redux";
import { removeUser } from "../../../slices/userSlice";
const { GET_CONSENT_BY_ID_FAILED } = failureMessageConstant;

const ConsentDetail = () => {
  const dispatch = useDispatch();
  const { IS_REFRESH_TOKEN_LOADING } = keyConstants;
  const params = useParams();
  const [states, setStates] = useState({
    consentData: [],
    isLoading: false
  });

  const changeState = (name, value) => {
    setStates((prevList) => ({
      ...prevList,
      [name]: value
    }));
  };

  useEffect(() => {
    const getConsentDetailById = async () => {
      const tokenStatus =
        await Utils.checkTokenExpireOrNot(getConsentDetailById);
      if (tokenStatus) {
        if (tokenStatus === IS_REFRESH_TOKEN_LOADING) {
          changeState("isLoading", true);
          return;
        }
        dispatch(removeUser({}));
        return;
      }
      try {
        changeState("isLoading", true);
        const consentData = await new UserConsent().getConsentDetailById(
          params?.id
        );
        changeState("consentData", consentData);
      } catch {
        Utils.failureToastMessage(GET_CONSENT_BY_ID_FAILED);
      } finally {
        changeState("isLoading", false);
      }
    };
    getConsentDetailById();
  }, []);
  return <ConsentDetailComponent states={states} />;
};

export default ConsentDetail;
